<template>
<b-container>
<h1>My Conferences</h1>
  <b-button-group size="sm">
    <b-button :pressed="attending" variant="outline-primary" @click='attending = true'>Attending</b-button>
    <b-button :pressed="!attending" variant="outline-primary" @click='attending = false'>Managing</b-button>
  </b-button-group>
  <div v-if="attending">
    <b-row>
      <!-- <b-col md="3" offset-md="4" class="my-1">
        <b-form-checkbox id="conferenceStatus"
                      v-model="conferenceStatus"
                      value="true"
                      unchecked-value="false"
                      @input="filter = ''">
        Active Conferences
      </b-form-checkbox>
      </b-col> -->
      <b-col md="3" offset-md="9" class="my-1">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" />
          <b-input-group-append>
          <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table striped
            hover
            :items="myConferences"
            :fields="fields"
            :filter="filter"
            stacked="md"
    >
    <template v-slot:cell(title)="data">
        {{data.item.conference.title | truncate('100') }}
    </template>
    <template v-slot:cell(conferenceStartDateTime)="data">
        {{data.item.conference.startDateTime.seconds | moment("from", "now")}}
    </template>
    <template v-slot:cell(actions)="row">
      <b-button variant="outline-danger" v-if="row.item.posterSubmission == 'I WILL BE submitting an abstract and will come back later and submit it'" @click="setConference(row.item.conference.Id, row.item.email)" v-b-modal.editMyRegistration>Add Abstract</b-button>
      <b-button-group>
        <b-dropdown variant="outline-success" right text="Actions">
          <b-dropdown-item @click="setConference(row.item.conference.Id, row.item.email)" v-b-modal.editMyRegistration>
            Details
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'AbstractBook', params: { conferenceId: row.item.conference.Id } }">
            Abstract Book
          </b-dropdown-item>
        </b-dropdown>
      </b-button-group>
    </template>
    </b-table>
  </div>
  <div v-if="!attending">
    <b-row>
      <!-- <b-col md="3" offset-md="4" class="my-1">
        <b-form-checkbox id="conferenceStatus"
                      v-model="conferenceStatus"
                      value="true"
                      unchecked-value="false"
                      @input="filter = ''">
        Active Conferences
      </b-form-checkbox>
      </b-col> -->
      <b-col md="3" offset-md="9" class="my-1">
        <b-input-group>
          <b-form-input v-model="adminFilter" placeholder="Type to Search" />
          <b-input-group-append>
          <b-btn :disabled="!adminFilter" @click="adminFilter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table striped
            hover
            :items="adminConferences"
            :fields="adminFields"
            :filter="adminFilter"
            stacked="md"
    >
    <template v-slot:cell(title)="data">
        {{data.item.title | truncate('100') }}
    </template>
    <template v-slot:cell(startDateTime)="data">
        {{data.item.startDateTime.seconds | moment("from", "now") }}
    </template>
    <template v-slot:cell(actions)="row">
      <b-button-group>
        <b-dropdown variant="outline-success" right text="Actions">
          <!-- <b-dropdown-item @click="setStatus(row.item.Id)" v-b-modal.editConference>
            Edit Conference</b-dropdown-item> -->
          <b-dropdown-item @click="setRegistrants(row.item.Id)" v-b-modal.editRegistrants>
            Manage Registrants</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'AbstractBook', params: { conferenceId: row.item.Id } }">
            Abstract Book</b-dropdown-item>
          <b-dropdown-item @click="setAttendeeDetails(row.item.Id)" v-b-modal.viewDetails>
            Attendee Details</b-dropdown-item>
            <b-dropdown-item @click="setStatus(row.item.Id)" v-b-modal.editConference>
            Edit Conference</b-dropdown-item>
            <b-dropdown-item variant="danger" @click="setDeleteConference(row.item.Id)" v-b-modal.deleteConference>
            Delete Conference</b-dropdown-item>
        </b-dropdown>
      </b-button-group>
    </template>
    </b-table>
  </div>
  <!-- Modal Component Edit Conference-->
    <b-form @submit="onSubmit" @reset="onReset" class="modal-form">
    <b-modal  id="editConference"
              size="lg"
              ref="editConference"
              title="Edit Conference Details"
              @ok="onSubmit"
              @cancel="onReset"
              ok-title="Submit"
              no-close-on-backdrop>
              <b-row v-if="form.logoURL">
                <b-col>
                  <div class="image-container">
                    <b-img :src=form.logoURL fluid thumbnail alt="Event Logo" />
                    <b-button class="delete-image-btn" variant="danger" @click="deleteImage">
                      <i class="fas fa-times"></i> Remove
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            <b-row>
            <b-col md="6">
                <b-form-group id="conferenceTitleInputGroup"
                                label="Conference or Event Title:"
                                label-for="conferenceTitleInput">
                    <b-form-input id="conferenceTitleInput"
                                type="text"
                                v-model="form.title"
                                maxlength=150
                                required
                                placeholder="Enter a title">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceLogoInputGroup"
                                label="Replace Logo"
                                label-for="conferenceLogoInput">
                    <b-form-file ref="fileinput" accept="image/*" :state="Boolean(file)" placeholder="Choose a file..." @change="detectFiles($event.target.files)"></b-form-file>
                    <div class="progress-bar" :style="{ width: progressUpload + '%'}">{{ progressUpload }}%</div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-form-group id="conferenceDescriptionInputGroup"
                                label="Description"
                                label-for="conferenceDescriptionInput">
                    <quill-editor id="conferenceDescription"
                            v-model="form.description"
                            ref="myQuillEditor"
                            :options="editorOptionExpanded">
                    </quill-editor>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceStartDateInputGroup"
                                label="Start Date:"
                                label-for="conferenceStartDateInput">
                    <b-form-input id="conferenceStartDateInput"
                                type="date"
                                v-model="form.startDate"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceStartTimeInputGroup"
                                label="Start Time:"
                                label-for="conferenceStartTimeInput">
                    <b-form-input id="conferenceStartTimeInput"
                                type="time"
                                v-model="form.startTime"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceEndDateInputGroup"
                                label="End Date:"
                                label-for="conferenceEndDateInput">
                    <b-form-input id="conferenceEndDateInput"
                                type="date"
                                v-model="form.endDate"
                                required
                                :state="dateState"
                                aria-describedby="inputLiveFeedback"
                                >
                    </b-form-input>
                  <b-form-invalid-feedback id="inputLiveFeedback">
                    End Date must be after the Start Date
                  </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceEndTimeInputGroup"
                                label="End Time:"
                                label-for="conferenceEndTimeInput">
                    <b-form-input id="conferenceEndTimeInput"
                                type="time"
                                v-model="form.endTime"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-form-group id="conferenceRegistrationDeadlineDateInputGroup"
                                label="Registration Deadline Date:"
                                label-for="conferenceRegistrationDeadlineDateInput">
                    <b-form-input id="conferenceRegistrationDeadlineDateInput"
                                type="date"
                                v-model="form.registrationDeadlineDate"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group id="conferenceRegistrationDeadlineTimeInputGroup"
                                label="Registration Deadline Time:"
                                label-for="conferenceRegistrationDeadlineTimeInput">
                    <b-form-input id="conferenceRegistrationDeadlineTimeInput"
                                type="time"
                                v-model="form.registrationDeadlineTime"
                                required
                                >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxActive"
                     v-model="form.conferenceActive"
                     >
                     Conference is active
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxPublicConference"
                     v-model="form.publicConference"
                     >
                     Enable simple public conference registration
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxTshirt"
                     v-model="form.askTShirt"
                     >
                     Ask Users T-Shirt Size
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxBreakfast"
                     v-model="form.askBreakfast"
                     >
                     Ask Users Breakfast Selection
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askBreakfast">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceBreakfastQuestionInputGroup"
                                label="Change Default Breakfast Question Text:"
                                label-for="conferenceBreakfastQuestionInput">
              <input type="text" v-model="form.breakfastQuestionText" class="form-control">
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askBreakfast">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceBreakfastOptionsInputGroup"
                                label="Specify Breakfast Options (hit enter after each option):"
                                label-for="conferenceBreakfastOptionsInput">
              <input-tag :tags.sync="form.breakfastOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxLunch"
                     v-model="form.askLunch"
                     >
                     Ask Users Lunch Selection
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askLunch">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceLunchQuestionInputGroup"
                                label="Change Default Lunch Question Text:"
                                label-for="conferenceLunchQuestionInput">
              <input type="text" v-model="form.lunchQuestionText" class="form-control">
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askLunch">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceLunchOptionsInputGroup"
                                label="Specify Lunch Options (hit enter after each option):"
                                label-for="conferenceLunchOptionsInput">
              <input-tag :tags.sync="form.lunchOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxDinner"
                     v-model="form.askDinner"
                     >
                     Ask Users Dinner Selection
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askDinner">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceDinnerQuestionInputGroup"
                                label="Change Default Dinner Question Text:"
                                label-for="conferenceDinnerQuestionInput">
              <input type="text" v-model="form.dinnerQuestionText" class="form-control">
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askDinner">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceDinnerOptionsInputGroup"
                                label="Specify Dinner Options (hit enter after each option):"
                                label-for="conferenceDinnerOptionsInput">
              <input-tag :tags.sync="form.dinnerOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxCME"
                     v-model="form.askCME"
                     >
                     Ask Users if they need CME credit
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxResearchBlitz"
                     v-model="form.askResearchBlitz"
                     >
                     Ask Users if they will participate in the Research Blitz
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxPosterSpecifics"
                     v-model="form.askPosterSpecifics"
                     >
                     Ask Users if they will submit a poster abstract
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askPosterSpecifics">
          <b-col md="12" class="text-left">
            <b-form-group id="conferencePosterCategoryInputGroup"
                                label="Specify Poster Category Options (hit enter after each option):"
                                label-for="conferencePosterCategoryInput">
              <input-tag :tags.sync="form.posterCategoryOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.askPosterSpecifics">
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxPosterSubmissionTopic"
                     v-model="form.askPosterSubmissionTopic"
                     >
                     Ask Users for a Submission Topic
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askPosterSubmissionTopic">
          <b-col md="12" class="text-left">
            <b-form-group id="conferencePosterSubmissionTopicInputGroup"
                                label="Specify Poster Submission Topic Options (hit enter after each option):"
                                label-for="conferencePosterSubmissionTopicInput">
              <input-tag :tags.sync="form.posterSubmissionTopicOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="form.extraPosterQuestions">
          <div v-for="extraPosterQuestion in form.extraPosterQuestions" :key="extraPosterQuestion.model">
            <b-row>
              <b-col md="12" class="text-left">
                <h4>{{extraPosterQuestion.label}}</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-select required v-model="extraPosterQuestion.type" :options="extraPosterQuestionOptions" class="mb-3" />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-input id="additionalInput"
                              type="text"
                              v-model="extraPosterQuestion.label"
                              placeholder="Please add a label for your question"
                              required
                              @keydown="nameKeydown($event)"
                  >
                  </b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row>
          <b-col md="8" class="text-left">
              <b-form-checkbox id="checkboxPosterJudging"
                     v-model="form.askPosterJudging"
                     >
                     Ask Users if they are interested in judging posters for this event
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8" class="text-left">
              <b-form-checkbox id="checkboxSpecialNeeds"
                     v-model="form.askSpecialNeeds"
                     >
                     Ask Users if they have any special considerations
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxSocialEvents"
                     v-model="form.askSocialEvents"
                     >
                     Ask Users if they will attend certain events
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.askSocialEvents">
          <b-col md="12" class="text-left">
            <b-form-group id="conferenceSocialEventsInputGroup"
                                label="Specify Special Event Options (hit enter after each option):"
                                label-for="conferenceSocialEventsInput">
              <input-tag :tags.sync="form.socialEventsOptions" class="form-control"></input-tag>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxEventReferral"
                     v-model="form.askEventReferral"
                     >
                     Ask Users how they heard about this event
              </b-form-checkbox>
          </b-col>
        </b-row>
        <div v-if="form.extraQuestions">
          <div v-for="extraQuestion in form.extraQuestions" :key="extraQuestion.model">
            <b-row>
              <b-col md="12" class="text-left">
                <h4>{{extraQuestion.label}}</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-select required v-model="extraQuestion.type" :options="extraQuestionOptions" class="mb-3" />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-input id="additionalInput"
                              type="text"
                              v-model="extraQuestion.label"
                              placeholder="Please add a label for your question"
                              required
                              @keydown="nameKeydown($event)"
                  >
                  </b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row>
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxConfirmationPage"
                     v-model="form.confirmationPage"
                     >
                     Redirect users to confirmation page after completing registration
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.confirmationPage">
            <b-col>
              <b-form-group id="conferenceConfirmationInputGroup"
                            label="Conference Confirmation Page"
                            label-for="conferenceConfirmationInput"
                            >
              <quill-editor v-model="form.conferenceConfirmation"
                            ref="myQuillEditor"
                            :options="editorOptionExpanded"
                            >
              </quill-editor>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxPaymentPage"
                     v-model="form.paymentPage"
                     >
                     Redirect users to payment page after completing registration
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="form.paymentPage">
            <b-col>
              <b-form-group id="conferencePaymentInputGroup"
                                label="Payment Page URL"
                                label-for="conferencePaymentInput">
                    <b-form-input id="conferencePaymentInput"
                                type="text"
                                v-model="form.paymentURL"
                                required
                                maxlength=255
                                placeholder="Enter a url">
                    </b-form-input>
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="conferenceWelcomeEmailInputGroup"
                            label="Conference Registration Welcome Email"
                            label-for="conferenceWelcomeEmailInput"
                            >
              <quill-editor v-model="form.conferenceWelcomeEmail"
                            ref="myQuillEditor"
                            :options="editorOption"
                            >
              </quill-editor>
              </b-form-group>
            </b-col>
          </b-row>
      <!-- <div slot="modal-footer">
          <b-button type="reset" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
       </div> -->
    </b-modal>
    </b-form>
  <!-- Modal Component Edit Registration-->
    <b-form class="modal-form">
    <b-modal  id="editMyRegistration"
              size="lg"
              ref="editMyRegistration"
              title="Edit My Conference Registration"
              ok-title="Submit"
              :ok-disabled="!state"
              @ok="onEventSubmit"
              no-close-on-backdrop>
       <b-row v-if="model.conference.askCME" class="form-row-margin">
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxMyCME"
                     v-model="model.cmeCredit"
                     >
                     I am requesting CME credit for this Event
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="model.conference.askResearchBlitz">
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxMyResearchBlitz"
                     v-model="model.askResearchBlitz"
                     >
                     I am participating in the Research Blitz
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="model.conference.askTShirt">
            <b-col md="6">
                <b-form-group id="conferenceTShirtInputGroup"
                                label="Choose a T-Shirt Size"
                                label-for="conferenceTShirtInput">
                    <b-form-select v-model="model.tShirtSize" :options="tShirtOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="model.conference.askBreakfast">
            <b-col md="6">
                <b-form-group id="conferenceBreakfastInputGroup"
                                label="Choose a Breakfast Option"
                                label-for="conferenceBreakfastInput">
                    <b-form-select v-model="model.breakfastSelection" :options="model.conference.breakfastOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="model.conference.askLunch">
            <b-col md="6">
                <b-form-group id="conferenceLunchInputGroup"
                                label="Choose a Lunch Option"
                                label-for="conferenceLunchInput">
                    <b-form-select v-model="model.lunchSelection" :options="model.conference.lunchOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="model.conference.askDinner">
            <b-col md="6">
                <b-form-group id="conferenceDinnerInputGroup"
                                label="Choose a Dinner Option"
                                label-for="conferenceDinnerInput">
                    <b-form-select v-model="model.dinnerSelection" :options="model.conference.dinnerOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="model.conference.askSpecialNeeds">
            <b-col>
              <b-form-group id="conferenceSpecialNeedsInputGroup"
                            label="Special Needs (500 character limit)"
                            label-for="conferenceSpecialNeedsInput"
                            :description="(500-model.specialNeeds.length).toString() + ' characters remaining'"
                            >
                <b-form-textarea v-model="model.specialNeeds"
                  type="textarea"
                  placeholder="Please let us know of any special needs (mobility/food allergies/etc.)"
                  :rows="4"
                  maxlength=500></b-form-textarea>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="model.conference.askSocialEvents">
            <b-col md="8">
              <b-form-group id="conferenceSocialEventsInputGroup"
                                  label="Please choose any special events you would like to attend"
                                  label-for="conferenceSocialEventsInput">
                <b-form-select multiple :select-size="4" v-model="model.socialEvents" :options="model.conference.socialEventsOptions" class="mb-3" />
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="model.extraQuestions" class="form-row-margin">
          <b-col md="12" class="text-left" v-for="extraQuestion in model.extraQuestions" :key="extraQuestion.model">
              <b-form-checkbox v-if="extraQuestion.type === 'radio'" :id="'extraQuestion['  + extraQuestion.model  + ']'"
                     v-model="model[extraQuestion.model]"
                     >
                     {{extraQuestion.label}}
              </b-form-checkbox>
              <b-form-group v-if="extraQuestion.type === 'input'"
                            :id="'extraQuestion['  + extraQuestion.model  + ']'"
                            class="label-heading"
                            :label=extraQuestion.label
                            label-align="left"
                            >
                <b-form-input v-model="model[extraQuestion.model]" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="model.conference.askPosterJudging" class="form-row-margin">
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxMyPosterJudging"
                     v-model="model.posterJudging"
                     >
                     I am interested in judging posters for this Event
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="model.conference.askPodiumPresentation" class="form-row-margin">
          <b-col md="12" class="text-left">
              <b-form-checkbox id="checkboxMyPodiumPresentation"
                     v-model="model.podiumPresentation"
                     >
                     I am interested in participating in podium presentations
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="model.conference.askPosterSpecifics || model.posterSubmission == 'I WILL submit an abstract and will enter it now' || model.posterSubmission == 'I WILL BE submitting an abstract and will come back later and submit it' || model.posterSubmission == 'I WILL submit an abstract'">
          <b-col md="8">
            <b-form-group id="conferencePosterSpecificsInputGroup"
                          label="Poster Abstract Submission"
                          label-for="conferencePosterSpecificsInput">
              <b-form-select v-model="model.posterSubmission" :options="posterSpecificOptions" class="mb-3" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="model.extraPosterQuestions" class="form-row-margin">
          <b-col md="12" class="text-left" v-for="extraPosterQuestion in model.extraPosterQuestions" :key="extraPosterQuestion.model">
              <b-form-checkbox v-if="extraPosterQuestion.type === 'radio'" :id="'extraPosterQuestion['  + extraPosterQuestion.model  + ']'"
                     v-model="model[extraPosterQuestion.model]"
                     >
                     {{extraPosterQuestion.label}}
              </b-form-checkbox>
              <b-form-group v-if="extraPosterQuestion.type === 'input'"
                            :id="'extraPosterQuestion['  + extraPosterQuestion.model  + ']'"
                            class="label-heading"
                            :label=extraPosterQuestion.label
                            label-align="left"
                            >
                <b-form-input v-model="model[extraPosterQuestion.model]" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <div v-if="model.posterSubmission == 'I WILL submit an abstract and will enter it now' || model.posterSubmission == 'I WILL submit an abstract'">
          <b-row>
            <b-col md="8">
              <b-form-group id="conferencePosterCategoryInputGroup"
                            label="Submission Category"
                            label-for="conferencePosterCategoryInput">
                <b-form-select v-model="model.posterSubmissionCategory" :options="model.conference.posterCategoryOptions" class="mb-3" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="model.conference.askPosterSubmissionTopic">
            <b-col md="6">
              <b-form-group id="conferenceosterSubmissionTopicInputGroup"
                                  label="Submission Topic"
                                  label-for="conferenceosterSubmissionTopicInput">
                <b-form-select v-model="model.posterSubmissionTopic" :options="model.conference.posterSubmissionTopicOptions" class="mb-3" />
              </b-form-group>
            </b-col>
          </b-row>
        <div class="form-row-margin">
          <b-card-group>
            <b-card
                header-tag="header"
                footer-tag="footer">
            <h6 slot="header" class="mb-0">Add Author to Poster</h6>
              <b-row class="form-row-margin">
                <b-col cols="12">
                  <input class="form-control" type="text" required v-model="author.firstName" placeholder="First Name">
                </b-col>
              </b-row>
              <b-row class="form-row-margin">
                <b-col cols="12">
                  <input class="form-control" type="text" required v-model="author.lastName" placeholder="Last Name">
                </b-col>
              </b-row>
              <b-row class="form-row-margin">
                <b-col cols="12">
                  <b-form-group label="Please select applicable credentials">
                    <b-form-select id="credentials" name="credentials" v-model="author.credentials" :options="options" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="form-row-margin">
                <b-col cols="12">
                  <input class="form-control" type="text" required v-model="author.department" placeholder="Department">
                </b-col>
              </b-row>
              <b-row class="form-row-margin">
                <b-col cols="12">
                  <b-form-group label="Please select an Institution or add one below">
                  <div>
                    <b-form-select v-model="author.institution" :options="institutions" size="lg" />
                  </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="form-row-margin">
                <b-col cols="12">
                  <input class="form-control" type="text" v-model="author.institution" placeholder="Or enter Institution here if not in dropdown">
                </b-col>
              </b-row>
              <b-button size="sm" variant="success" class="mr-1" slot="footer" @click="addAuthor">
                Add Author
              </b-button>
            </b-card>
          </b-card-group>
        </div>
          <b-row class="form-row-margin" v-for="(item, index) in model.posterAuthors" :key="index">
            <b-col sm="12" md="6">
              <div>
                <b-card-group deck>
                  <b-card
                        header-tag="header"
                        footer-tag="footer"
                  >
                    <h6 slot="header" class="mb-0">{{item.firstName}} {{item.lastName}} {{item.credentials}}</h6>
                    <b-button-group slot="footer">
                      <b-button v-if="index !=0" variant="success" @click="reorderAuthors(index, index-1)">Move Up</b-button>
                      <b-button v-if="index+1 != model.posterAuthors.length" variant="primary" @click="reorderAuthors(index, index+1)">Move Down</b-button>
                      <b-button variant="danger" @click="removeAuthor(index)">Delete Author</b-button>
                    </b-button-group>
                    <p class="card-text">Department: {{item.department}}</p>
                    <p class="card-text">Institution: {{item.institution}}</p>
                  </b-card>
                </b-card-group>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="conferencePosterSubmissionTitleInputGroup"
                            label="Submission Title"
                            label-for="conferencePosterSubmissionTitleInput">
                <b-input-group size="lg" :append="(150-model.posterSubmissionTitle.length).toString() + ' characters remaining'">
                <b-form-input v-model="model.posterSubmissionTitle"
                  type="text"
                  placeholder="Enter your Poster Title"
                  maxlength=150></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
         <b-row>
            <b-col>
              <b-form-group id="conferencePosterSubmissionAbstractInputGroup"
                            label="Submission Abstract (3000 character limit)"
                            label-for="conferencePosterSubmissionAbstractInput"
                            :invalid-feedback="invalidFeedback"
                            :valid-feedback="validFeedback"
                            :state="state"
                            >
              <quill-editor v-model="model.posterSubmissionAbstract"
                            ref="myQuillEditor"
                            :options="editorOption"
                            @change="onEditorChange($event)">
              </quill-editor>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
    </b-modal>
    </b-form>
  <!-- Modal Component Edit Registrants-->
    <b-form class="modal-form">
    <b-modal  id="editRegistrants"
              size="lg"
              ref="editRegistrants"
              title="Edit Conference Registrants"
              hide-footer
              ok-title="Submit"
              @hide="resetRegistrants"
              no-close-on-backdrop>
              <b-row>
                <b-col md="3" offset-md="5">
                  <div class='link'>
                    <download-excel
                      class = "btn btn-info m-2"
                      :data = "conferenceRegInfo"
                      name = "registrantData.xls">
                    Download Data
                    </download-excel>
                  </div>
                </b-col>
                <b-col md="4">
                  <div>
                    <b-dropdown id="ddownEmail" text="Email Groups of Users" variant="primary" class="m-2">
                      <b-dropdown-item :href="'mailto:?bcc=' + allRegistrantsEmail">All Users</b-dropdown-item>
                      <b-dropdown-item :href="'mailto:?bcc=' + posterPresenterRegistrantsEmail">Poster Presenters</b-dropdown-item>
                      <b-dropdown-item :href="'mailto:?bcc=' + posterJudgesRegistrantsEmail">Poster Judges</b-dropdown-item>
                      <b-dropdown-item :href="'mailto:?bcc=' + cmeRegistrantsEmail">Requesting CME Credit</b-dropdown-item>
                      <b-dropdown-item :href="'mailto:?bcc=' + posterOutstandingAbstractsRegistrantsEmail">Pending Abstracts</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </b-col>
              </b-row>
              <b-table striped hover :items="registrants" :fields="registrantFields" stacked="md">
                <template v-slot:cell(actions)="row">
                  <b-button-group>
                    <b-dropdown variant="outline-success" right text="Actions">
                      <b-dropdown-item v-if="user.uid !== row.item.adminId" @click="setConference(conferenceId, row.item.email)" v-b-modal.editMyRegistration>
                        Edit Registration
                      </b-dropdown-item>
                      <b-dropdown-item v-if="user.uid !== row.item.adminId" @click="removeUser(row.item.uid, editingConference, row.item.email, row.item.registrationCreatedAt)">
                        Remove User
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-button-group>
                </template>
              </b-table>
    </b-modal>
    </b-form>
    <!-- Modal Component Delete Conference-->
    <b-modal  id="deleteConference"
              size="lg"
              ref="deleteConference"
              title="Confirm Deletion"
              ok-title="Delete"
              @ok="onDelete"
              no-close-on-backdrop
              >
          <b-row class="modal-row-space">
            <b-col>
              <b-alert variant="danger" show>Are you sure you want to delete the conference entirely?  This action cannon be undone.</b-alert>
            </b-col>
          </b-row>
    </b-modal>
    <!-- Modal Component View Conference Details-->
    <b-modal  id="viewDetails"
              size="lg"
              ref="viewDetails"
              title="Conference Details"
              hide-footer
              ok-title="Submit"
              @hide="resetAttendeeDetails"
              no-close-on-backdrop
              >
          <b-row class="modal-row-space">
            <b-col>
              <b-list-group>
                <b-list-group-item variant="primary" class="d-flex justify-content-between align-items-center" v-if="conferenceDetails.registrants">
                  Number of Registrations
                  <b-badge variant="warning" v-if="conferenceDetails.registrants" pill>{{conferenceDetails.registrants}}</b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <b-row class="modal-row-space">
            <b-col v-if="conferenceDetails.breakfastNeeded && conferenceDetails.askBreakfast">
              <b-card-group deck>
                <b-card header="<b>Breakfast Count</b>">
                  <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(item, index) in conferenceDetails.breakfastNeeded" :key="index" v-if="item != 0">
                      {{index}}
                      <b-badge variant="primary" pill>{{item}}</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-card-group>
            </b-col>
            <b-col v-if="conferenceDetails.lunchesNeeded && conferenceDetails.askLunch">
              <b-card-group deck>
                <b-card header="<b>Lunch Count</b>">
                  <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(item, index) in conferenceDetails.lunchesNeeded" :key="index" v-if="item != 0">
                      {{index}}
                      <b-badge variant="primary" pill>{{item}}</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-card-group>
            </b-col>
            <b-col v-if="conferenceDetails.dinnersNeeded && conferenceDetails.askDinner">
              <b-card-group deck>
                <b-card header="<b>Dinner Count</b>">
                  <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(item, index) in conferenceDetails.dinnersNeeded" :key="index" v-if="item != 0">
                      {{index}}
                      <b-badge variant="primary" pill>{{item}}</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-card-group>
            </b-col>
            <b-col v-if="conferenceDetails.tShirtsNeeded && conferenceDetails.askTShirt">
              <b-card-group deck>
                <b-card header="<b>T-Shirt Count</b>">
                  <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(item, index) in conferenceDetails.tShirtsNeeded" :key="index" v-if="item != 0">
                      {{index}}
                      <b-badge variant="primary" pill>{{item}}</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card-group deck v-if="conferenceDetails.socialEventsCount && conferenceDetails.askSocialEvents">
                <b-card header="<b>Special Events Count</b>">
                  <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(item, index) in conferenceDetails.socialEventsCount" :key="index" v-if="item != 0">
                      {{index}}
                      <b-badge variant="primary" pill>{{item}}</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>
    </b-modal>
</b-container>
</template>

<script>
import { db, storage } from '../main'
import Firebase from 'firebase/compat/app'

export default {
  name: 'MyConferences',
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    userProfile () {
      return this.$store.getters.getUserProfile
    },
    dateState () {
      return this.form.endDate === '' ? null : (new Date(this.form.endDate)) >= (new Date(this.form.startDate)) ? true : false
    }
  },
  filters: {
    truncate (value, stop, clamp) {
      return value.slice(0, stop) + (stop < value.length ? clamp || '...' : '')
    }
  },
  data () {
    return {
      adminConferences: [],
      attending: true,
      extraQuestionOptions: [
        {value: {type: null, inputType: null, label: ''}, text: 'Please select a question type'},
        {value: 'input', text: 'Text Field'},
        {value: 'radio', text: 'Yes/No Question'}
      ],
      extraPosterQuestionOptions: [
        {value: {type: null, inputType: null, label: ''}, text: 'Please select a question type'},
        {value: 'input', text: 'Text Field'},
        {value: 'radio', text: 'Yes/No Question'}
      ],
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['clean']
          ]
        }
      },
      editorOptionExpanded: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'align': [] }],
            ['link'],
            ['clean']
          ]
        }
      },
      state: true,
      validFeedback: '',
      invalidFeedback: '',
      posterSpecificOptions: [
        {value: null, text: 'Please choose whether or not you will submit an abstract'},
        'I am not submitting an abstract',
        'I WILL submit an abstract',
        'I WILL BE submitting an abstract and will come back later and submit it'
      ],
      tShirtOptions: [
        {value: null, text: 'Please select a T-Shirt Size'},
        {value: 'Small', text: 'Small'},
        {value: 'Medium', text: 'Medium'},
        {value: 'Large', text: 'Large'},
        {value: 'XL', text: 'X-Large'},
        {value: 'XXL', text: 'XX-Large'},
        {value: 'None', text: 'No T-Shirt Wanted'}
      ],
      myAdminConferences: [],
      formOptions: {},
      onValidated: '',
      myConferences: [],
      progressUpload: 0,
      file: File,
      uploadTask: '',
      downloadURL: '',
      form: [],
      show: true,
      conference: [],
      registrantFields: [
        { key: 'displayName', label: 'Name', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'institution', label: 'Institution' },
        { key: 'actions', label: 'Actions' }
      ],
      fields: [
        { key: 'conference.title', label: 'Title' },
        { key: 'conferenceStartDateTime', label: 'Conference Start' },
        { key: 'actions', label: 'Actions' }
      ],
      adminFields: [
        { key: 'title', label: 'Title', sortable: true },
        { key: 'startDateTime', label: 'Conference Start' },
        { key: 'actions', label: 'Actions' }
      ],
      author: {
        credentials: null,
        department: null,
        departmentInstitution: null,
        firstName: '',
        institution: null,
        lastName: '',
        locationIndex: null
      },
      filter: null,
      adminFilter: null,
      conferenceStatus: true,
      modalConferenceId: '',
      conferenceId: '',
      registrants: [],
      editingConference: '',
      registrationId: '',
      conferenceDetails: {},
      allRegistrantsEmail: [],
      posterPresenterRegistrantsEmail: [],
      posterJudgesRegistrantsEmail: [],
      cmeRegistrantsEmail: [],
      posterOutstandingAbstractsRegistrantsEmail: [],
      conferenceRegInfo: [],
      conferenceInfo: [],
      conferenceDelete: '',
      previousRegistrationInfo: [],
      singleConferenceRegInfo: [],
      model: {
        posterSubmissionAbstract: '',
        specialNeeds: '',
        posterSubmissionTitle: '',
        conference: {},
        posterPresenterLocations: []
      },
      options: [
        { value: null, text: 'None' },
        { value: 'MD', text: 'MD' },
        { value: 'PhD', text: 'PhD' },
        { value: 'MD, PhD', text: 'MD, PhD' },
        { value: 'MS', text: 'MS' },
        { value: 'RN', text: 'RN' },
        { value: 'PharmD', text: 'PharmD' },
        { value: 'DDS', text: 'DDS' },
        { value: 'DMD, ScD', text: 'DMD, ScD' },
        { value: 'DVM, PhD', text: 'DVM, PhD' },
        { value: 'PhD, D.Sc', text: 'PhD, D.Sc' },
        { value: 'D.Sc', text: 'D.Sc' },
        { value: 'DO', text: 'DO' },
        { value: 'Other', text: 'Other' }
      ],
      institutions: []
    }
  },
  firestore () {
    return {
      myConferences: db.collection('Registrations').where('userId', '==', this.$store.getters.getUser.uid).orderBy('conference.startDateTime'),
      institutions: db.collection('Institutions').orderBy('id')
    }
  },
  methods: {
    nameKeydown (e) {
      if (e.key === '.') {
        e.preventDefault()
      }
    },
    resetRegistrants () {
      this.registrants = []
      this.allRegistrantsEmail = []
      this.posterPresenterRegistrantsEmail = []
      this.posterJudgesRegistrantsEmail = []
      this.cmeRegistrantsEmail = []
      this.posterOutstandingAbstractsRegistrantsEmail = []
      this.conferenceId = ''
      this.conferenceRegInfo = []
      this.allRegistrantsEmail = []
    },
    removeUser (userId, conferenceId, userEmail, createdAt) {
      if (userId) {
        db.collection('Registrations').where('userId', '==', userId).where('conference.Id', '==', conferenceId)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              db.collection('Registrations').doc(doc.id).delete().then(x => {
                console.log('Document successfully deleted!')
                var batch = db.batch()
                var conferenceDocRef = db.collection('Conferences').doc(conferenceId)
                return db.runTransaction(transaction => {
                  return transaction.get(conferenceDocRef).then(conferenceDoc => {
                    if (!conferenceDoc.exists) {
                      throw new Error('Document does not exist!')
                    }
                    var newRegistrantCount = (conferenceDoc.data().registrants || 0) - 1
                    batch.update(conferenceDocRef, {registrants: newRegistrantCount})
                    if (doc.data().breakfastSelection) {
                      var breakfastUpdate = 'breakfastNeeded.' + doc.data().breakfastSelection
                      var newBreakfastCount = (conferenceDoc.data().breakfastNeeded[doc.data().breakfastSelection] || 0) - 1
                      batch.update(conferenceDocRef, {[breakfastUpdate]: newBreakfastCount})
                    }
                    if (doc.data().lunchSelection) {
                      var lunchUpdate = 'lunchesNeeded.' + doc.data().lunchSelection
                      var newLunchCount = (conferenceDoc.data().lunchesNeeded[doc.data().lunchSelection] || 0) - 1
                      batch.update(conferenceDocRef, {[lunchUpdate]: newLunchCount})
                    }
                    if (doc.data().dinnerSelection) {
                      var dinnerUpdate = 'dinnersNeeded.' + doc.data().dinnerSelection
                      var newDinnerCount = (conferenceDoc.data().dinnersNeeded[doc.data().dinnerSelection] || 0) - 1
                      batch.update(conferenceDocRef, {[dinnerUpdate]: newDinnerCount})
                    }
                    if (doc.data().tShirtSize) {
                      var tShirtUpdate = 'tShirtsNeeded.' + doc.data().tShirtSize
                      var newTShirtCount = (conferenceDoc.data().tShirtsNeeded[doc.data().tShirtSize] || 0) - 1
                      batch.update(conferenceDocRef, {[tShirtUpdate]: newTShirtCount})
                    }
                    batch.commit().then(x => {
                      this.registrants = this.registrants.filter(function (obj) {
                        return obj.uid !== userId
                      })
                    })
                  })
                }).then(function () {
                  console.log('Transaction successfully committed!')
                  this.$router.replace('/myconferences')
                }).catch(function (error) {
                  console.log('Transaction failed: ', error)
                })
              }).catch(function (error) {
                console.error('Error removing document: ', error)
              })
            })
          })
          .catch(function (error) {
            console.log('Error getting documents: ', error)
          })
      } else {
        db.collection('Registrations').where('email', '==', userEmail).where('conference.Id', '==', conferenceId).where('registrationCreatedAt', '==', createdAt)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              db.collection('Registrations').doc(doc.id).delete().then(x => {
                console.log('Document successfully deleted!')
                var batch = db.batch()
                var conferenceDocRef = db.collection('Conferences').doc(conferenceId)
                return db.runTransaction(transaction => {
                  return transaction.get(conferenceDocRef).then(conferenceDoc => {
                    if (!conferenceDoc.exists) {
                      throw new Error('Document does not exist!')
                    }
                    var newRegistrantCount = (conferenceDoc.data().registrants || 0) - 1
                    batch.update(conferenceDocRef, {registrants: newRegistrantCount})
                    if (doc.data().breakfastSelection) {
                      var breakfastUpdate = 'breakfastNeeded.' + doc.data().breakfastSelection
                      var newBreakfastCount = (conferenceDoc.data().breakfastNeeded[doc.data().breakfastSelection] || 0) - 1
                      batch.update(conferenceDocRef, {[breakfastUpdate]: newBreakfastCount})
                    }
                    if (doc.data().lunchSelection) {
                      var lunchUpdate = 'lunchesNeeded.' + doc.data().lunchSelection
                      var newLunchCount = (conferenceDoc.data().lunchesNeeded[doc.data().lunchSelection] || 0) - 1
                      batch.update(conferenceDocRef, {[lunchUpdate]: newLunchCount})
                    }
                    if (doc.data().dinnerSelection) {
                      var dinnerUpdate = 'dinnersNeeded.' + doc.data().dinnerSelection
                      var newDinnerCount = (conferenceDoc.data().dinnersNeeded[doc.data().dinnerSelection] || 0) - 1
                      batch.update(conferenceDocRef, {[dinnerUpdate]: newDinnerCount})
                    }
                    if (doc.data().tShirtSize) {
                      var tShirtUpdate = 'tShirtsNeeded.' + doc.data().tShirtSize
                      var newTShirtCount = (conferenceDoc.data().tShirtsNeeded[doc.data().tShirtSize] || 0) - 1
                      batch.update(conferenceDocRef, {[tShirtUpdate]: newTShirtCount})
                    }
                    batch.commit().then(x => {
                      this.registrants = this.registrants.filter(function (obj) {
                        return obj.uid !== userId
                      })
                    })
                  })
                }).then(function () {
                  console.log('Transaction successfully committed!')
                  this.$router.replace('/myconferences')
                }).catch(function (error) {
                  console.log('Transaction failed: ', error)
                })
              }).catch(function (error) {
                console.error('Error removing document: ', error)
              })
            })
          })
          .catch(function (error) {
            console.log('Error getting documents: ', error)
          })
      }
    },
    setConference (conferenceId, email) {
      db.collection('Registrations').where('email', '==', email).where('conference.Id', '==', conferenceId)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.model = doc.data()
            this.previousRegistrationInfo = doc.data()
            this.registrationId = doc.id
          })
        })
        .catch(function (error) {
          console.log('Error getting documents: ', error)
        })
    },
    setDeleteConference (conferenceInfo) {
      this.conferenceDelete = conferenceInfo
    },
    setStatus (conferenceId) {
      var conferenceDocRef = db.collection('Conferences').doc(conferenceId)
      conferenceDocRef.get().then(doc => {
        this.form = doc.data()
        this.modalConferenceId = conferenceId
      }).catch(function (error) {
        console.log('Error getting document: ', error)
      })
    },
    resetAttendeeDetails () {
      this.conferenceDetails = []
    },
    setAttendeeDetails (conferenceId) {
      var docRef = db.collection('Conferences').doc(conferenceId)
      docRef.get().then(doc => {
        this.conferenceDetails = doc.data()
      }).catch(function (error) {
        console.log('Error getting document: ', error)
      })
    },
    setRegistrants (conferenceId) {
      this.resetRegistrants()
      this.conferenceId = conferenceId
      db.collection('Registrations').where('conference.Id', '==', conferenceId)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if (doc.data().posterSubmission === 'I WILL submit an abstract and will enter it now' || doc.data().posterSubmission === 'I WILL submit an abstract') {
              this.posterPresenterRegistrantsEmail.push(doc.data().email)
            }
            if (doc.data().posterJudging) {
              this.posterJudgesRegistrantsEmail.push(doc.data().email)
            }
            if (doc.data().cmeCredit) {
              this.cmeRegistrantsEmail.push(doc.data().email)
            }
            if (doc.data().posterSubmission === 'I WILL BE submitting an abstract and will come back later and submit it') {
              this.posterOutstandingAbstractsRegistrantsEmail.push(doc.data().email)
            }
            if (doc.data().userId) {
              var docRef = db.collection('metadata').doc(doc.data().userId)
              docRef.get().then(reg => {
                if (reg.exists) {
                  this.registrants.push(doc.data())
                  this.singleConferenceRegInfo = {...doc.data(), ...reg.data()}
                  delete this.singleConferenceRegInfo.conference
                  delete this.singleConferenceRegInfo.posterPresenterLocations
                  delete this.singleConferenceRegInfo.posterAuthors
                  delete this.singleConferenceRegInfo.posterSubmissionAbstract
                  delete this.singleConferenceRegInfo.admin
                  delete this.singleConferenceRegInfo.canAssignDepartments
                  delete this.singleConferenceRegInfo.canChangeRole
                  delete this.singleConferenceRegInfo.canCreateConference
                  delete this.singleConferenceRegInfo.canEditProfile
                  delete this.singleConferenceRegInfo.userId
                  delete this.singleConferenceRegInfo.uid
                  delete this.singleConferenceRegInfo.department
                  delete this.singleConferenceRegInfo.departmentManagement
                  this.conferenceRegInfo.push(this.singleConferenceRegInfo)
                  this.singleConferenceRegInfo = {}
                  this.conferenceInfo = []
                  this.allRegistrantsEmail.push(reg.data().email)
                } else {
                  // doc.data() will be undefined in this case
                  console.log('No such document!')
                }
              }).catch(function (error) {
                console.log('Error getting document: ', error)
              })
            } else {
              this.registrants.push(doc.data())
              const extras = {}
              const posterExtras = {}
              for (const extraQuestion in doc.data().extraQuestions) {
                extras[extraQuestion] = doc.data().extraQuestions[extraQuestion]
              }
              for (const extraPosterQuestion in doc.data().extraPosterQuestions) {
                posterExtras[extraPosterQuestion] = doc.data().extraPosterQuestions[extraPosterQuestion]
              }
              let obj = {}
              obj = { ...doc.data(), ...extras, ...posterExtras }
              Object.keys(obj).forEach(key => {
                if (obj[key] === null) {
                  delete obj[key]
                }
              })
              delete obj.conference
              delete obj.extraPosterQuestions
              delete obj.extraQuestions
              delete obj.posterAuthors
              obj.registrationCreatedAt = new Date(obj.registrationCreatedAt.seconds * 1000)
              this.conferenceRegInfo.push(obj)
              this.allRegistrantsEmail.push(doc.data().email)
            }
          })
        })
        .catch(function (error) {
          console.log('Error getting documents: ', error)
        })
      this.$refs.editRegistrants.show()
      this.editingConference = conferenceId
    },
    onEventSubmit (evt) {
      if (this.model.posterSubmission !== 'I WILL submit an abstract and will enter it now' && this.model.posterSubmission !== 'I WILL submit an abstract') {
        this.model.posterSubmissionCategory = ''
        this.model.posterSubmissionTitle = ''
        this.model.posterSubmissionAbstract = ''
      }
      var batch = db.batch()
      this.model.posterPresenterLocations = []
      if (this.model.posterAuthors.length > 0) {
        this.model.posterAuthors.forEach(author => {
          this.model.posterPresenterLocations.push(author.departmentInstitution)
        })
        this.model.posterPresenterLocations = [...new Set(this.model.posterPresenterLocations)]
        this.model.posterAuthors.forEach((author, index, authorArray) => {
          this.model.posterAuthors[index].locationIndex = this.model.posterPresenterLocations.indexOf(author.departmentInstitution)
        })
      }
      var docRef = db.collection('Registrations').doc(this.registrationId)
      batch.update(docRef, this.model)
      batch.commit().then(function () {})
      var conferenceDocRef = db.collection('Conferences').doc(this.model.conference.Id)
      conferenceDocRef.get().then(conferenceDoc => {
        if (conferenceDoc.exists) {
          var batch = db.batch()
          if (this.model.breakfastSelection !== this.previousRegistrationInfo.breakfastSelection) {
            var breakfastRemove = 'breakfastNeeded.' + this.previousRegistrationInfo.breakfastSelection
            var newBreakfastRemoveCount = (conferenceDoc.data().breakfastNeeded[this.previousRegistrationInfo.breakfastSelection] || 0) - 1
            var breakfastUpdate = 'breakfastNeeded.' + this.model.breakfastSelection
            var newBreakfastCount = (conferenceDoc.data().breakfastNeeded[this.model.breakfastSelection] || 0) + 1
            batch.update(conferenceDocRef, {
              [breakfastUpdate]: newBreakfastCount,
              [breakfastRemove]: newBreakfastRemoveCount
            })
          }
          if (this.model.lunchSelection !== this.previousRegistrationInfo.lunchSelection) {
            var lunchRemove = 'lunchesNeeded.' + this.previousRegistrationInfo.lunchSelection
            var newLunchRemoveCount = (conferenceDoc.data().lunchesNeeded[this.previousRegistrationInfo.lunchSelection] || 0) - 1
            var lunchUpdate = 'lunchesNeeded.' + this.model.lunchSelection
            var newLunchCount = (conferenceDoc.data().lunchesNeeded[this.model.lunchSelection] || 0) + 1
            batch.update(conferenceDocRef, {
              [lunchUpdate]: newLunchCount,
              [lunchRemove]: newLunchRemoveCount
            })
          }
          if (this.model.dinnerSelection !== this.previousRegistrationInfo.dinnerSelection) {
            var dinnerRemove = 'dinnersNeeded.' + this.previousRegistrationInfo.dinnerSelection
            var newDinnerRemoveCount = (conferenceDoc.data().dinnersNeeded[this.previousRegistrationInfo.dinnerSelection] || 0) - 1
            var dinnerUpdate = 'dinnersNeeded.' + this.model.dinnerSelection
            var newDinnerCount = (conferenceDoc.data().dinnersNeeded[this.model.dinnerSelection] || 0) + 1
            batch.update(conferenceDocRef, {
              [dinnerUpdate]: newDinnerCount,
              [dinnerRemove]: newDinnerRemoveCount
            })
          }
          if (this.model.tShirtSize !== this.previousRegistrationInfo.tShirtSize) {
            var tShirtRemove = 'tShirtsNeeded.' + this.previousRegistrationInfo.tShirtSize
            var tShirtRemoveCount = (conferenceDoc.data().tShirtsNeeded[this.previousRegistrationInfo.tShirtSize] || 0) - 1
            var tShirtUpdate = 'tShirtsNeeded.' + this.model.tShirtSize
            var newTShirtCount = (conferenceDoc.data().tShirtsNeeded[this.model.tShirtSize] || 0) + 1
            batch.update(conferenceDocRef, {
              [tShirtUpdate]: newTShirtCount,
              [tShirtRemove]: tShirtRemoveCount
            })
          }
          if (this.model.socialEvents || this.previousRegistrationInfo.socialEvents) {
            Array.prototype.diff = function (a) {
              return this.filter(function (i) { return a.indexOf(i) < 0 })
            }
            var diffRemove = this.previousRegistrationInfo.socialEvents.diff(this.model.socialEvents)
            var diffAdd = this.model.socialEvents.diff(this.previousRegistrationInfo.socialEvents)
            diffRemove.forEach(event => {
              var eventRemove = 'socialEventsCount.' + event
              var eventRemoveCount = (conferenceDoc.data().socialEventsCount[event] || 0) - 1
              batch.update(conferenceDocRef, {
                [eventRemove]: eventRemoveCount
              })
            })
            diffAdd.forEach(event => {
              var eventAdd = 'socialEventsCount.' + event
              var eventAddCount = (conferenceDoc.data().socialEventsCount[event] || 0) + 1
              batch.update(conferenceDocRef, {
                [eventAdd]: eventAddCount
              })
            })
          }
          batch.commit().then(function () {})
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!')
        }
      }).catch(function (error) {
        console.log('Error getting document: ', error)
      })
    },
    onDelete (evt) {
      db.collection('Conferences').doc(this.conferenceDelete).delete().then(function () {
        console.log('Document successfully deleted!')
      }).catch(function (error) {
        console.error('Error removing document: ', error)
      })
      this.adminConferences = []
      if (this.userProfile.departmentManagement.length > 0) {
        this.userProfile.departmentManagement.forEach(element => {
          db.collection('Conferences').where('department', '==', element.value)
            .onSnapshot(querySnapshot => {
              querySnapshot.forEach(doc => {
                this.adminConferences.push(doc.data())
                this.adminConferences[this.adminConferences.length - 1].Id = doc.id
              })
            })
        })
      }
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.form.Id = this.modalConferenceId
      this.form.startDateTime = new Date(this.form.startDate + ' ' + this.form.startTime)
      this.form.endDateTime = new Date(this.form.endDate + ' ' + this.form.endTime)
      this.form.registrationDateTime = new Date(this.form.registrationDeadlineDate + ' ' + this.form.registrationDeadlineTime)
      var modalSubmit = this.form
      if (this.dateState) {
        var docRef = db.collection('Conferences').doc(this.form.Id)
        return db.runTransaction(function (transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(docRef).then(Doc => {
            if (!Doc.exists) {
              throw new Error('Document does not exist!')
            }
            transaction.update(docRef, modalSubmit)
          })
        }).then(docs => {
          console.log('Transaction successfully committed!')
          db.collection('Registrations').where('conference.Id', '==', this.form.Id)
            .get()
            .then(querySnapshot => {
              querySnapshot.forEach(function (doc) {
                // Create a reference to the SF doc.
                var docRef = db.collection('Registrations').doc(doc.id)
                db.runTransaction(function (transaction) {
                  return transaction.get(docRef).then(doc => {
                    if (!doc.exists) {
                      throw new Error('Document does not exist!')
                    }
                    delete modalSubmit.schema
                    transaction.update(docRef, { conference: modalSubmit })
                  })
                }).then(function () {
                  console.log('Transaction successfully committed!')
                }).catch(function (error) {
                  console.log('Transaction failed: ', error)
                })
              })
            })
            .catch(function (error) {
              console.log('Error getting documents: ', error)
            })
          this.form = {}
          this.$refs.editConference.hide()
        }).catch(function (error) {
          console.log('Transaction failed: ', error)
        })
      }
    },
    onCancel () {
      this.$refs.editConference.hide()
    },
    onReset (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form = {}
      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => { this.show = true })
      this.$refs.editConference.hide()
    },
    detectFiles (fileList) {
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload (file) {
      if (this.form.logoName) {
        const storageRef = storage.ref()
        const imageRef = storageRef.child('images/' + this.form.logoName)
        imageRef.delete().catch(error => {
          console.error('Error removing old file:', error)
        })
      }

      const storageRef = storage.ref()
      const fileRef = storageRef.child('images/' + file.name)
      this.uploadTask = fileRef.put(file)

      this.uploadTask.on('state_changed', 
        (snapshot) => {
          this.progressUpload = Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
        },
        (error) => {
          console.error('Upload error:', error)
        },
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL()
            .then(downloadURL => {
              this.downloadURL = downloadURL
              this.form.logoURL = downloadURL
              this.form.logoName = file.name
            })
            .catch(error => {
              console.error('Error getting download URL:', error)
            })
        }
      )
    },
    addAuthor () {
      this.author.locationIndex = null
      this.author.departmentInstitution = this.author.department + ' ' + this.author.institution
      this.model.posterAuthors.push(this.author)
      this.author = {
        credentials: null,
        department: null,
        departmentInstitution: null,
        firstName: '',
        institution: null,
        lastName: '',
        locationIndex: null
      }
    },
    reorderAuthors (index, newIndex) {
      // eslint-disable-next-line no-extend-native
      Array.prototype.move = function (from, to) {
        this.splice(to, 0, this.splice(from, 1)[0])
      }
      this.model.posterAuthors.move(index, newIndex)
    },
    removeAuthor (index) {
      this.model.posterAuthors.splice(index, 1)
    },
    onEditorChange (event) {
      this.state = event.text.length <= 3000 ? true : false
      if (this.state) {
        this.validFeedback = 3000 - event.text.length + ' characters remaining'
      } else { this.invalidFeedback = 3000 - event.text.length + ' characters remaining' }
    },
    deleteImage () {
      if (this.form.logoName) {
        const storageRef = storage.ref()
        const imageRef = storageRef.child('images/' + this.form.logoName)
        imageRef.delete().then(() => {
          this.form.logoURL = null
          this.form.logoName = null
          this.downloadURL = null
          this.progressUpload = 0
        }).catch(error => {
          console.error('Error removing file:', error)
        })
      }
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      })
    }
  },
  mounted () {
    db.collection('metadata').doc(Firebase.auth().currentUser.uid).onSnapshot(doc => {
      doc.data().departmentManagement.forEach(element => {
        db.collection('Conferences').where('department', '==', element.value)
          .onSnapshot(querySnapshot => {
            querySnapshot.forEach(doc => {
              this.adminConferences.push(doc.data())
              this.adminConferences[this.adminConferences.length - 1].Id = doc.id
            })
          })
      })
    })
  }
}
</script>
<style scoped>
.b-form-group, .vue-form-generator {
  text-align: left;
}
.btn {
  border-radius: 0px!important;
}
.modal-row-space {
  margin-bottom: 15px;
}
.form-row-margin {
  margin-bottom: 15px;
}
.form-control.vue-input-tag-wrapper {
  min-height: 38px;
  overflow-y: auto;
}
#conferenceosterSubmissionTopicInputGroup .form-control.vue-input-tag-wrapper {
  min-height: 150px;
}
.image-container {
  position: relative;
  display: inline-block;
}

.delete-image-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  opacity: 0.9;
}

.delete-image-btn:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/MyConferences.vue